/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const KeyImportRequest: core.serialization.Schema<
    serializers.KeyImportRequest.Raw,
    Omit<Truvity.KeyImportRequest, 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    data: core.serialization.string(),
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace KeyImportRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        data: string;
        labels?: Record<string, string> | null;
    }
}
